import { useEffect, useState } from "react";
import { Typography } from "@/core/components/ui/typography";
import { dayjs } from "@/core/utils/date";
import { cn } from "@/core/utils/utils";

interface RelativeTimeProps {
  timestamp: string;
  prefix?: string;
  className?: string;
}

export const RelativeTime = ({
  timestamp,
  prefix,
  className,
}: RelativeTimeProps) => {
  const [relativeTime, setRelativeTime] = useState("");

  useEffect(() => {
    const updateRelativeTime = () => {
      setRelativeTime(dayjs(timestamp).fromNow());
    };

    // Update immediately
    updateRelativeTime();

    // Update every minute
    const interval = setInterval(updateRelativeTime, 60000);

    return () => clearInterval(interval);
  }, [timestamp]);

  return (
    <Typography
      variant="bodyW3"
      textColor="secondary"
      className={cn("text-sm", className)}
    >
      {prefix && `${prefix} `}
      {relativeTime}
    </Typography>
  );
};
